import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AgeGateProvider } from "@/context/AgeGateContext";
import { MusicProvider, useMusic } from "@/context/MusicContext";
import AgeGate from "@/components/AgeGate";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MusicWidget from "@/components/MusicWidget";
import MuscleMan from "@/components/MuscleMan";
import ScrollToTop from "@/components/ScrollToTop";
import PageTransition from "@/components/PageTransition";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Rates from "@/pages/Rates";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBio from "@/pages/admin/AdminBio";
import AdminRates from "@/pages/admin/AdminRates";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminTiers from "@/pages/admin/AdminTiers";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminPayments from "@/pages/admin/AdminPayments";

function AgeGateWithMusic({ children }) {
  const { setMuted } = useMusic();
  return (
    <AgeGateProvider onConfirm={() => setMuted(false)}>
      {children}
    </AgeGateProvider>
  );
}

function Layout({ children }) {
  return (
    <div className="App min-h-screen relative">
      <AgeGate />
      <Navbar />
      <main>{children}</main>
      <Footer />
      <MusicWidget />
      <MuscleMan />
    </div>
  );
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <PageTransition>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/rates" element={<Rates />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/account" element={<Account />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="bio" element={<AdminBio />} />
          <Route path="rates" element={<AdminRates />} />
          <Route path="media" element={<AdminMedia />} />
          <Route path="tiers" element={<AdminTiers />} />
          <Route path="bookings" element={<AdminBookings />} />
          <Route path="messages" element={<AdminMessages />} />
          <Route path="payments" element={<AdminPayments />} />
        </Route>
      </Routes>
    </PageTransition>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <MusicProvider>
        <AgeGateWithMusic>
          <AuthProvider>
            <Toaster
              theme="dark"
              position="top-center"
              toastOptions={{
                style: {
                  background: "#1A1115",
                  color: "#F5EFE8",
                  border: "1px solid rgba(255, 20, 147, 0.3)",
                },
              }}
            />
            <Layout>
              <AnimatedRoutes />
            </Layout>
          </AuthProvider>
        </AgeGateWithMusic>
      </MusicProvider>
    </BrowserRouter>
  );
}
